// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const iron_hands: PokeData = {
  "id": 992,
  "name": "iron-hands",
  "height": 18,
  "weight": 3807,
  "base_experience": 285,
  "types": [
    PokeType.FIGHTING,
    PokeType.ELECTRIC
  ],
  "api_moves": [
    "thunder-punch",
    "whirlwind",
    "slam",
    "sand-attack",
    "tackle",
    "seismic-toss",
    "focus-energy",
    "belly-drum",
    "detect",
    "fake-out",
    "focus-punch",
    "charge",
    "arm-thrust",
    "close-combat",
    "force-palm",
    "heavy-slam",
    "wild-charge"
  ],
  "moves": [
    "thunder-punch",
    "tackle",
    "seismic-toss",
    "close-combat",
    "wild-charge",
    "volt-switch",
    "zap-cannon",
    "rolling-kick",
    "superpower",
    "thunder-fang",
    "thunder",
    "coaching",
    "meteor-assault"
  ],
  "evolution_chain": {
    "id": 523,
    "item": null,
    "species": [
      {
        "name": "iron-hands",
        "order": 989,
        "types": [
          PokeType.FIGHTING,
          PokeType.ELECTRIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 156,
    "speed": 64,
    "ability_power": 180
  },
  "stat_changes": [],
  "catch_rate": 50,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
